module.exports = __webpack_public_path__ + "img/CADdetails.aba521dd.jpeg";